module.exports = __webpack_public_path__ + "img/splash.5d057b0b.jpg";